// extracted by mini-css-extract-plugin
export default {"main":"Tab_main__TjD5E","active":"Tab_active__eHbBO"};